import styled from 'styled-components'

import { helpers } from 'styles'

export const Header = styled.header`
	align-items: center;
	background-color: ${helpers.color.pageHeader};
	color: ${helpers.color.white};
	display: flex;
	height: 78px;
	justify-content: space-between;
	padding: 12px 32px;

	> svg,
	> button {
		flex-shrink: 0;
	}

	> svg {
		height: 42px;
		width: 42px;
	}

	@media only screen and (max-width: 800px) {
		padding: 12px 16px;
	}
`
